import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=4cce0268&"
import script from "./ConfirmPassword.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports